import {
  GET_PRICE_LEVELS_REQUESTED,
  GET_PRICE_LEVELS_SUCCEEDED,
  GET_PRICE_LEVELS_FAILED,
  UPDATE_PRICE_LEVELS_REQUESTED,
  UPDATE_PRICE_LEVELS_SUCCEEDED,
  UPDATE_PRICE_LEVELS_FAILED,
  CREATE_PRICE_LEVELS_REQUESTED,
  CREATE_PRICE_LEVELS_SUCCEEDED,
  CREATE_PRICE_LEVELS_FAILED,
} from 'store/PriceLevels/constants'
import api from 'utils/api'
export const createPriceLevelRequested = () => ({
  type: CREATE_PRICE_LEVELS_REQUESTED,
})

export const createPriceLevelSucceeded = (payload) => ({
  type: CREATE_PRICE_LEVELS_SUCCEEDED,
  payload,
})

export const createPriceLevelFailed = () => ({
  type: CREATE_PRICE_LEVELS_FAILED,
})

export const updatePriceLevelRequested = () => ({
  type: UPDATE_PRICE_LEVELS_REQUESTED,
})

export const updatePriceLevelSucceeded = (payload) => ({
  type: UPDATE_PRICE_LEVELS_SUCCEEDED,
  payload,
})

export const updatePriceLevelFailed = () => ({
  type: UPDATE_PRICE_LEVELS_FAILED,
})

export const getPriceLevelsRequested = () => ({
  type: GET_PRICE_LEVELS_REQUESTED,
})

export const getPriceLevlesSucceeded = (payload) => ({
  type: GET_PRICE_LEVELS_SUCCEEDED,
  payload,
})

export const getPriceLevelsFailed = () => ({
  type: GET_PRICE_LEVELS_FAILED,
})

export const loadPriceLevels = (venueUuid) => (dispatach) => {
  dispatach(getPriceLevelsRequested())

  return api
    .fetchPriceLevels(venueUuid)
    .then((response) =>
      dispatach(
        getPriceLevlesSucceeded(response.data.itemPropertyOverrides)
      )
    )
    .catch(() => dispatach(getPriceLevelsFailed()))
}

export const updatePriceLevel = (data, venueUuid) => (dispatch) => {
  dispatch(updatePriceLevelRequested())

  return api
    .updatePriceLevel(data)
    .then((response) =>
      dispatch(
        updatePriceLevelSucceeded(response.data.itemPropertyOverrides)
      )
    )
    .then(() => dispatch(loadPriceLevels(venueUuid)))
    .catch(() => dispatch(updatePriceLevelFailed()))
}

export const createPriceLevel = (data, venueUuid) => (dispatch) => {
  dispatch(createPriceLevelRequested())

  return api
    .createPriceLevel(data)
    .then((response) =>
      dispatch(
        createPriceLevelSucceeded(response.data.itemPropertyOverrides)
      )
    )
    .then(() => dispatch(loadPriceLevels(venueUuid)))
    .catch(() => dispatch(createPriceLevelFailed()))
}
